var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgHomepageKSymbollink(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Homepage_K-symbol_link",
    "data-name": "Homepage K-symbol link",
    xmlns: "http://www.w3.org/2000/svg",
    width: 30,
    height: 60,
    viewBox: "0 0 30 60",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_2",
    "data-name": "Path 2",
    d: "M44.09,49.926l20-20-10-10-20,20v20h0l20,20,10-10Zm-7.666,4.366v-13.4L54.09,23.226l6.7,6.7L42.44,48.276ZM54.09,76.626,35.74,58.276l6.7-6.7,18.35,18.35Z",
    transform: "translate(-34.09 -19.926)",
    fill: "#0084cc"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHomepageKSymbollink);
export default __webpack_public_path__ + "static/media/Homepage K-symbol link.7802bd2b16e3ddbbfde628477065ded4.svg";
export { ForwardRef as ReactComponent };